/*

  this is the main (and only) public entry point to the application from the browser
  debug, info, warn, error, and RequestLogger are exported for isomorphic
  compatibility with the nodejs entrypoiny (node.js)

*/

const BaseLogger = require('./logger')
const sanitize = require('./sanitize')
const constants = require('./constants')
const levels = require('./levels')

/**
 * The client cannot determine the app name or log level using configurator/configment right now it needs to be
 * set manually. In the case where it is not, we provide a sensible default.
 */

var configuration = {
  singletonConfig: {},
  get: function get () { return Object.assign({}, this.singletonConfig) },
  set: function set (config) { this.singletonConfig = Object.assign({}, config) },
  update: function update (config) { Object.assign(this.singletonConfig, config) },
  reset: function reset () { this.set({ level: 'info', appName: 'ten-x' }) },
}
configuration.reset()

/**
 * Styles we use to add minor style to browser console logging.
 */
const baseStyles = `
  color: #fff;
  text-transform: uppercase;
  padding: 3px 6px;
`.trim()

const levelStyles = {
  debug: `${baseStyles}
  background-color: ${constants.BROWSER_DEBUG_COLOR};
  `.trim(),
  info: `${baseStyles}
  background-color: ${constants.BROWSER_INFO_COLOR};
  `.trim(),
  warn: `${baseStyles}
  background-color: ${constants.BROWSER_WARN_COLOR};
  `.trim(),
  error: `${baseStyles}
  background-color: ${constants.BROWSER_ERROR_COLOR};
  `.trim(),
}

class BrowserLogger extends BaseLogger {
  static forModule (modReference) {
    return new BrowserLogger(modReference)
  }

  _logAtLevel (level, ...messages) {
    const appName = configuration.get().appName
    let loggerPrefix = null

    if (messages.length > 1 && messages[0].startsWith(constants.LOGGER_REFERENCE_PREFIX)) {
      loggerPrefix = messages[0]
        .replace(constants.LOGGER_REFERENCE_PREFIX, '')
        .replace(constants.LOGGER_REFERENCE_SUFFIX, '')
        .trim()

      messages = messages.slice(1)
    }

    messages = messages.map(arg => sanitize(arg))

    if (levels[level] >= levels[configuration.get().level]) {
      console.log(`%c${loggerPrefix || appName}`, levelStyles[level], ...messages) // eslint-disable-line no-console
    }
  }
}

function RequestLogger () {
  this.logger = BrowserLogger.forModule('RequestLogger')

  this.request = this.response = function (...args) {
    this.logger.info(...args) // eslint-disable-line no-console
  }
}

/**
 * Match the Isomorphic API
 */
BrowserLogger.prototype.RequestLogger = RequestLogger
BrowserLogger.prototype.configuration = configuration

// Wish we could use Reflection for this but our apps don't have this rule enabled in babel...
BrowserLogger.prototype.forModule = BrowserLogger.forModule

module.exports = new BrowserLogger()
